import styles from "../styles/style.module.css";
import { LOCAL_CONSTANTS } from "../../../lib/constants";
import moment from "moment";

interface FreeOrdersListProp {
  loading: boolean;
  users: any;
}

const FreeOrdersList = ({ loading, users }: FreeOrdersListProp) => {
  return (
    <div className={styles.scrollTable}>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone Number</th>
            <th>Travelling Country</th>
            <th>Handset Model No</th>
            <th>Created Date</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={7} align="center" className={styles.loadingText}>
                {LOCAL_CONSTANTS.loading}
              </td>
            </tr>
          )}
          {!loading && users.list.length === 0 && (
            <tr>
              <td colSpan={7} align="center">
                No User Found
              </td>
            </tr>
          )}
          {!loading &&
            users.list.map((item: any, index: number) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>
                  {item.firstName || LOCAL_CONSTANTS.na}{" "}
                  {item.lastName || ""}
                </td>
                <td>{item.email || LOCAL_CONSTANTS.na}</td>
                <td>{item.phoneNumber || LOCAL_CONSTANTS.na}</td>
                <td>
                  {item.travellingCountry?.name || LOCAL_CONSTANTS.na}
                </td>
                <td>{item.handsetModelNo || LOCAL_CONSTANTS.na}</td>
                <td>
                  {item.createdAt
                    ? moment(item.createdAt).format(LOCAL_CONSTANTS.dateFormat)
                    : LOCAL_CONSTANTS.na}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default FreeOrdersList;

